export default __webpack_public_path__ + "static/media/step-4-en.c33e05a8.svg";